import { render, staticRenderFns } from "./product-roles-layout.vue?vue&type=template&id=2615a401"
import script from "./product-roles-layout.vue?vue&type=script&lang=js"
export * from "./product-roles-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports